<template>
  <v-container fluid style="padding-left: 300px">
    <v-row>
      <v-col cols="12">
        <v-form @submit.prevent="searchPosts">
          <v-card elevation="0" tile outlined>
            <v-card-text>
                <div class="mt-3">検索条件を入力してください</div>
                <v-layout row>
                  <v-text-field
                    v-model="searchQuery.id_eq"
                    label="記事ID"
                    style="max-width: 150px"
                    type="number"
                    clearable
                    class="ma-2"
                  />
                  <v-text-field
                    v-model="searchQuery.title_or_introduction_cont"
                    label="キーワード"
                    style="max-width: 400px"
                    clearable
                    class="ma-2"
                  />
                  <v-text-field
                    v-model="searchQuery.userNameCont"
                    label="作成者"
                    style="max-width: 150px"
                    clearable
                    class="ma-2"
                  />
                  <v-text-field
                    v-model="searchQuery.writerable_name_cont"
                    label="ライター名"
                    style="max-width: 150px"
                    clearable
                    class="ma-2"
                  />
                  <v-select
                    v-model="searchQuery.statusObject"
                    :items="selectableStatuses"
                    item-text="type"
                    style="max-width: 150px"
                    class="ma-2"
                    item-value="value"
                    clearable
                    return-object
                    label="ステータス"
                  />
                  <v-select
                    v-model="searchQuery.post_type_eq"
                    :items="selectablePostTypes"
                    item-value="value"
                    style="max-width: 150px"
                    class="ma-2"
                    clearable
                    label="記事種別"
                  />
                  <div class="ma-2">
                    <SelectableTags
                      v-model="tags"
                      :site-key="siteKey"
                      label="タグ"
                    />
                  </div>
                </v-layout>
                <div class="text-center">
                  <v-btn
                    color="primary"
                    dark
                    rounded
                    class="px-10 my-2"
                    type="submit"
                    @click="searchPosts"
                    @submit.prevent="searchPosts"
                  >
                    検索
                  </v-btn>
                </div>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12">
        <AdminPostTable
          :posts="posts"
          :site="selectedSite()"
          @delete-post="deletePost"
          @post-download-url="postDownloadUrl"
          @post-duplicate="postDuplicate"
        />

        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import Qs from 'qs'
import { mapState, mapGetters } from 'vuex'
import { deserialize } from 'deserialize-json-api'
import AdminPostTable from '@/components/commons/AdminPostTable'
import headUtilsMixin from '@/mixins/head_utils'
import SelectableTags from './SelectableTags'
import blobDownloader from '@/mixins/blob_downloader'

export default {
  name: 'Posts',
  components: {
    InfiniteLoading,
    AdminPostTable,
    SelectableTags
  },
  mixins: [headUtilsMixin, blobDownloader],
  data: () => {
    return {
      pageTitle: '記事一覧',
      posts: [],
      page: 1,
      siteKey: null,
      searchQuery: {
        advanced_status_query: null,
        composite_status_eq: null,
        id_eq: '',
        post_title_cont: '',
        statusObject: null,
        status_eq: '',
        recent_order_status_eq: '',
        title_or_introduction_cont: null,
        writerable_name_cont: '',
        tags_id_eq_any: [],
        userNameCont: ''
      },
      selectableStatuses: [
        { type: '未応募', value: 0, model: 'order' },
        { type: '執筆中', value: 10, model: 'order' },
        { type: '検収中', value: 30, model: 'order' },
        { type: '公開', value: 1001, model: 'post' },
        { type: '非公開', value: 1002, model: 'post' },
        { type: '下書き', value: 1000, model: 'post' }
      ],
      selectablePostTypes: [
        { text: '通常記事', value: 0 },
        { text: '商品記事', value: 1 }
      ],
      orderStatusColors: {
        not_applied: '',
        writing: 'primary',
        under_inspection: 'warning',
        completed: 'success'
      },
      infiniteId: +new Date(),
      tags: []
    }
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => state.UserAuthStore.currentUserAuth
    }),
    ...mapGetters('UserAuthStore', ['selectableSites'])
  },
  watch: {
    tags () {
      this.searchQuery.tags_id_eq_any = this.tags.map((tag) => tag.id)
    },
    siteKey () {
      this.searchPosts()
    }
  },
  created () {
    this.$watch(
      () => this.$route.params,
      (params) => {
        this.siteKey = params.siteKey
      }
    )
  },
  mounted () {
    this.siteKey = this.$route.params.siteKey
  },
  methods: {
    searchPosts () {
      this.searchQuery.status_eq = ''
      this.searchQuery.recent_order_status_eq = ''
      this.page = 1
      this.posts = []
      this.infiniteId++
      this.searchParamsKeyChange()
    },
    searchParamsKeyChange () {
      if (!this.searchQuery.statusObject) {
        return true
      }
      if (this.searchQuery.statusObject.model == 'order') {
        this.searchQuery.recent_order_status_eq = this.searchQuery.statusObject.value
      } else {
        this.searchQuery.status_eq = this.searchQuery.statusObject.value - 1000
      }
    },
    selectedSite () {
      return this.currentUserAuth.sites.find(
        (site) => site.siteKey == this.siteKey
      )
    },
    infiniteHandler ($state) {
      if (!this.siteKey) {
        $state.complete()
        return true
      }
      axios
        .get('/api/master/posts', {
          params: {
            page: this.page,
            site_key: this.siteKey,
            q: this.searchQuery
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedPosts = deserialize(data).data
          if (fetchedPosts.length > 0) {
            this.page++
            this.posts = this.posts.concat(fetchedPosts)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    deletePost (postId) {
      this.$store.dispatch('LoaderStore/displayLoader')
      const params = { params: { siteKey: this.siteKey } }
      axios
        .delete(`/api/master/posts/${postId}`, params)
        .then(
          () => {
            const index = this.posts.findIndex((v) => v.id === postId)
            this.posts.splice(index, 1)
            const payload = {
              status: 200,
              message: '記事を削除しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    postDownloadUrl (postId) {
      axios
        .get(`/api/master/html_export/${postId}`, { responseType: 'blob', params: { site_key: this.siteKey } })
        .then(
          (response) => {
            this.downloadBlob(response)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.messages
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    postDuplicate (postId) {
      const params = { site_key: this.siteKey }
      axios.post(`/api/master/posts/${postId}/duplicates`, params).then(
        () => {
          const payload = {
            status: 200,
            message: '複製しました。'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.searchPosts()
        },
        () => {
          const payload = {
            status: 404,
            message: '複製に失敗しました。'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style scoped></style>
